const maxSizeLimit = 10 * 1000 * 1000;

const validateTotUploadSize = (array) => {
  const total = array?.reduce((acc, file) => acc + file.size, 0);
  return total < maxSizeLimit ? true : false;
};

export { validateTotUploadSize };
